<template>
    <div class="register-box" :style="`height:100vh;`">
        <div class="content-box">
            <div class="left-box">
                <p class="name">智能建造</p>
                <p class="name-1">虚拟仿真数字平台</p>
                <img style="margin-top: 50px;height: 40px;" src="../../assets/image/login/text.png" alt="">
                <p style="margin-top: 15px;" class="describe">海量虚仿一流课程免费共享</p>
                <p class="describe">丰富多样的学习资源</p>
                <p class="describe">数据分析、掌握学情</p>
                <p class="describe">多维度、更广阔的学习空间</p>
            </div>
            <div class="right-box">
                <i class="el-icon-close close-flag" v-if="isBackendSys" @click="changeOperation(false)"></i>
                <div class="sys-name">虚仿实训教学平台</div>
                <div class="first-box">
                    <p class="register" @click="changeLogin(0)" :class="{ 'zd-register': registerType == 0 }">账号登录</p>
                    <img style="width: 25px;" v-if="registerType == 0" src="../../assets/image/login/des.png" alt="">
                    <p @click="changeLogin(1)" :class="{ 'zd-register': [1,2].includes(registerType)}" class="register"
                        style="margin-left: 20px;">企业微信登录</p>
                    <img style="width: 25px;" v-if="[1,2].includes(registerType)" src="../../assets/image/login/des.png" alt="">
                </div>
                <div v-if="registerType == 0">
                    <div class="input-box">
                        <img style="width: 15px;" src="../../assets/image/login/account.png" alt="">
                        <el-select v-model="phone" style="width: 110px;" placeholder="">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.loginName" maxlength="11" @keydown.enter.native="enterLogin"
                            placeholder="请输入账号"></el-input>
                    </div>
                    <div class="input-box">
                        <img style="width: 15px;" src="../../assets/image/login/password.png" alt="">
                        <el-input v-model="form.passwd" type="password" @keydown.enter.native="enterLogin"
                            placeholder="请输入登录密码"></el-input>
                    </div>
                    <div class="input-box">
                        <img style="width: 15px;" src="../../assets/image/login/txyzm.png" alt="">
                        <el-input maxlength="4" v-model="form.code" @keydown.enter.native="enterLogin"
                            placeholder="请输入图形验证码"></el-input>
                        <img class="img" @click="queryCodeImg" :src="imgUrl" alt="">
                    </div>
                    <div class="bottom-box">
                        <div @click="changeRoute('replace')">忘记密码？</div>
                        <div @click="changeRoute('register')">立即注册</div>
                    </div>
                    <div class="btn-box" v-debounce="save">登录</div>
                </div>
                <div class="type-box" v-else-if="registerType == 1">
                    <div id="wxLoginContainer"></div>
                </div>
                <div v-else>
                    <div class="input-box">
                        <img style="width: 15px;" src="../../assets/image/login/account.png" alt="">
                        <el-select v-model="phone" style="width: 110px;" placeholder="">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.loginName" maxlength="11"
                            placeholder="请输入账号"></el-input>
                    </div>
                    <div class="input-box">
                        <el-input v-model="form.passwd"  type="passward"
                            placeholder="请输入密码"></el-input>
                    </div>
                    <p style="white-space: normal;color: var(--grey);margin-top: 20px;"><span class="iconfont icon-tishi"></span> 首次通过企业微信扫码登录系统，需先完成企业微信账号与系统账号的绑定关联。</p>
                    <div class="btn-box" style="margin-top: 40px;" v-debounce="save">登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { QueryImgCode, CaptchaLogin, QueryCode, GetWechatConfig, WechatLogin } from '@/api/common/common';
import { SyncUserInfo } from '@/api/systemAuth';
import { HomeRoute, PlanRoute } from '@/utils/enum';
import { QueryResource } from '@/api/common/common';
import { QueryUserInfo } from '@/api/user';
import Utils from "@/assets/js/Utils";
import CryptoJS from 'crypto-js';
import { QueryAppDetail } from '@/api/common/common';
export default {
    components: { },
    data() {
        return {
            form: {
                "code": "",
                "key": "",
                "loginName": "",
                "passwd": "",
                "phoneCode": "",
                "userName": "",
                "wechartUserId":'111'
            },
            /**账号或者密码登录 */
            registerType: '',
            phone: '86',
            /**图片验证码url */
            imgUrl: '',
            /**手机验证码获取倒计时 */
            countdown: 0,
            options: [
                {
                    label: '+86',
                    value: '86'
                }
            ],
            isBackendSys: true,
        }
    },
    computed: {
        /**是否存在上一级路由 */
        isLastRoute() {
            return this.$store.state.menu.isLastRoute;
        }
    },
    methods: {
        changeOperation(value) {
            this.$store.commit('changeGoLogin', value);
        },
        /**获取用户信息 */
        queryUserInfo() {
            return new Promise(resolve => {
                QueryUserInfo().then(res => {
                    if (res.code == 200) {
                        this.$store.commit('changeUserInfo', res.data);
                        resolve();
                    }
                })
            })
        },
        /**获取企业微信的配置 */
        getWechatConfig() {
            let wx=document.querySelector('#wxLoginContainer');
            if(wx)wx.innerHTML='';
            GetWechatConfig().then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    new window.WwLogin({
                        id: "wxLoginContainer",    // 容器ID
                        appid: data.corpid,        // 企业微信管理后台获取
                        agentid: data.agentid,     // 网页应用ID
                        redirect_uri: data.url, // 编码后的回调地址
                        state: "web_login%40gyoss9",       // 可选
                        href: location.origin +'/css/wechat.css', // 自定义CSS的HTTPS链接
                    },
                    );
                }
            })
        },
        wechatLogin(code) {
            let params = {
                "appCode": process.env.VUE_APP_APPCODE,
                "code": code,
                "device": "",
                "loginName": "",
                "passwordless": true,
                "wechartUserId": ""
            }
            WechatLogin(params).then(res => {
                if (res.code == 200) {
                    this.loginMsg(res.data);
                }else if(res.code==6001){
                    this.form.wechartUserId=res.msg;
                    this.registerType=2;
                }else{
                    this.$msg({
                            showClose: true,
                            message: res.msg,
                            type: "error",
                        });
                    this.getWechatConfig();
                }
            })
        },
        changeRoute(path) {
            this.$store.commit('changeGoLogin', path);
        },
        /**清空输入框 */
        clearInput() {
            for (let key in this.form) {
                this.form[key] = '';
            }
        },
        /**获取应用详情 */
        queryAppDetail() {
            QueryAppDetail({ id: process.env.VUE_APP_APP_CODE }).then(res => {
                if (res.code == 200) {
                    this.$store.commit('changeAppInfo', res.data);
                }
            })
        },
        /**点击enter登录 */
        enterLogin() {
            this.captchaLogin();
        },
        /**切换登录方式 */
        changeLogin(type) {
            this.registerType = type;
            if (type == 0) {
                this.clearInput();
                this.queryCodeImg();
            } else {
                this.getWechatConfig();
            }
        },
        /**递归处理菜单 */
        handleMenu(data) {
            data.forEach((item, index) => {
                var obj = {
                    label: item.name,
                    value: item.url.slice(1),
                    permission: item.url.slice(1),
                    children: item.children || [],
                    show: true,
                    path: item.url
                };
                data[index] = obj;
                if (item.children && item.children.length > 0) {
                    this.handleMenu(item.children);
                }
            })
            return data;
        },
        /**获取资源权限 */
        queryResource() {
            QueryResource({ appCode: process.env.VUE_APP_APP_CODE }).then(res => {
                if (res.code == 200) {
                    var navList = this.handleMenu(res.data.horizontalMenuList);
                    var menuList = this.handleMenu(res.data.menuList);
                    navList.unshift(HomeRoute);
                    navList.push(PlanRoute);
                    var magSysList = menuList.find(item => {
                        return item.value == 'magSys';
                    });
                    if (magSysList) {
                        magSysList.show = false;
                        magSysList = magSysList.children || [];
                    }
                    this.$store.commit('changeMagSysList', magSysList || []);
                    this.$store.commit('updateNavList', navList);
                    this.$store.dispatch('setPermissions', res.data.permissions);
                    let route = null;
                    if (this.$route.meta.classify == 'manage') {
                        if (magSysList && magSysList.length > 0) {
                            route = '/magSys' + magSysList[0].path;
                            this.$router.push(route);
                            this.$store.commit('changeCurrentMagNav', magSysList[0]);
                        } else {
                            route = '/';
                            this.$router.push('/');
                        }
                    }
                    if (route == this.$route.path || !route) {
                        this.changeOperation(false);
                    }
                }
            })
        },
        save() {
            if (this.registerType == 0) {
                this.captchaLogin();
            } else {
                let data={
                        "appCode": '',
                        "code": '',
                        "device": "",
                        "loginName": this.form.loginName,
                        "passwd":CryptoJS.MD5(this.form.passwd).toString(),
                        "passwordless": true,
                        "wechartUserId": this.form.wechartUserId
                    };
                    WechatLogin(data).then(res1=>{
                        if(res1.code==200){
                            this.loginMsg(res1.data);
                        }else{
                            this.$msg({
                            showClose: true,
                            message: res1.msg,
                            type: "error",
                        });
                        }
                    });
            }
        },
        /**获取图片验证码 */
        queryCodeImg() {
            var params = {
                "generatorType": '1',
                "height": 44,
                "type": '3',
                "width": 110,
                "appCode": process.env.VUE_APP_APP_CODE,
                'bizType': 0
            }
            QueryImgCode(params).then(res => {
                if (res.code == 200) {
                    this.imgUrl = res.data.img;
                    this.form.key = res.data.key;
                    this.form.code = '';
                }
            })
        },
        /**获取手机验证码 */
        queryPhoneCode() {
            var params = {
                "captcha": this.form.code,
                "key": this.form.key,
                "number": this.form.loginName,
                "type": 0
            }
            QueryCode(params).then(res => {
                if (res.code == 200) {
                    this.form.phoneCode = res.data;
                    this.countdown = 60;
                    var timer = setInterval(() => {
                        this.countdown--;
                        if (this.countdown == 0) {
                            clearInterval(timer);
                        }
                    }, 1000)
                }
            }).catch(err => {
                this.queryCodeImg();
            })
        },
        /**登录存储信息 */
        loginMsg(data){
                    this.$store.commit('home/changeRouteAlive', false);
                    this.$nextTick(function () {
                        this.$store.commit('home/changeRouteAlive', true);
                    })
                    this.$store.dispatch('setUserData', data);
                    // this.$store.commit('changeUserInfo', data);
                    this.queryAppDetail();
                    this.queryUserInfo();
                    Utils.$emit('user-login');
                    this.queryResource();
                    SyncUserInfo().then(res => {
                        if (res.code == 200) {
                            this.$store.commit('queryUserName', res.data);
                        }
                    });
        },
        /**账号登录 */
        captchaLogin() {
            var params = {
                "appCode": process.env.VUE_APP_APP_CODE,
                "captcha": this.form.code,
                "device": "",
                "key": this.form.key,
                "loginName": this.form.loginName,
                "passwd": CryptoJS.MD5(this.form.passwd).toString()
            }
            CaptchaLogin(params).then(res => {
                if (res.code == 200) {
                   this.loginMsg(res.data);
                }
            }).catch(err => {
                this.queryCodeImg();
            })
        },
        /**监听微信消息 */
        listenWx(e){
            if (
                e.origin !== "https://open.work.weixin.qq.com" ||
                typeof e.data !== "string" ||
                !e.data.startsWith("http")
            ) return;
            e.stopImmediatePropagation(); // 阻止其他监听器执行
            e.preventDefault();         // 阻止默认跳转行为
            // 解析 URL 中的 code
            const url = new URL(e.data);
            const code = url.searchParams.get("code");
            if (code) {
                this.wechatLogin(code);
                // 在此处处理 code（如发送到后端）
            }else{
                this.$msg({
                            showClose: true,
                            message: '获取code失败',
                            type: "error",
                        });
                this.getWechatConfig();
            }
            return;
        }
    },
    mounted() {
        let classify = this.$route.meta.classify;
        window.addEventListener('message',this.listenWx,false)
        if (classify == 'manage') {
            this.isBackendSys = false;
        } else {
            this.isBackendSys = true;
        }
        this.queryCodeImg();
    },
    beforeDestroy(){
        window.removeEventListener('message',this.listenWx);
    }
}
</script>

<style lang="less" scoped>
.register-box {
    width: 100%;
    background-image: url('../../assets/image/login/register.png');
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    font-size: 14px;
}

.count-down {
    width: 100px;
    height: 32px;
    position: absolute;
    background-color: rgb(232, 240, 254);
    right: 14px;
    top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
    font-size: 12px;
}

.content-box {
    display: flex;
    align-items: center;
}

.left-box {
    width: 340px;
    height: 530px;
    background: rgba(0, 17, 165, 1);
    border-radius: 16px 0px 0px 16px;
    padding: 36px;

    .top-box {
        display: flex;
        cursor: pointer;

        i {
            cursor: pointer;
            font-size: 16px;
            margin-right: 5px;
        }
    }

    .name {
        font-size: 30px;
        text-align: center;
        margin-top: 85px;
    }

    .name-1 {
        font-size: 26px;
        font-weight: 700;
        margin-top: 35px;
    }

    .describe {
        font-size: 14px;
        text-align: center;
        margin-top: 12px;
    }
}

.right-box {
    width: 460px;
    height: 500px;
    background: #ffffff;
    border-radius: 0px 16px 16px 0px;
    padding: 60px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    position: relative;

    .close-flag {
        position: absolute;
        top: 20px;
        right: 20px;
        color: #000000;
        font-size: 18px;
        cursor: pointer;
    }
}

.back-box {
    color: #000000;
    display: flex;
    cursor: pointer;

    i {
        font-size: 16px;
        margin-right: 5px;
    }
}

.zd-register {
    color: #387DFF !important;
    font-weight: 700;
    font-size: 20px;
}

.first-box {
    display: flex;
    align-items: center;
    margin-top: 23px;
}

.btn-box {
    width: 100%;
    height: 40px;
    background: linear-gradient(-90deg, #72bbff 0%, #387dff 100%);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    margin-top: 10px;
    cursor: pointer;
}

.input-box {
    height: 44px;
    background-color: #FAFBFF;
    border-radius: 6px;
    margin-top: 14px;
    padding: 15px;
    display: flex;
    align-items: center;
    position: relative;

    .img {
        width: 110px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
    }
}

/deep/.el-input__inner {
    border: none;
    background-color: #FAFBFF;
}

/deep/.el-button--primary {
    background-color: #ffffff;
}

.bottom-box {
    display: flex;
    justify-content: space-between;
    color: #8590B3;
    margin-top: 30px;

    &> :nth-child(n) {
        cursor: pointer;
    }
}

.sys-name {
    color: #000000;
    font-size: 24px;
    white-space: var(--lineWrap);
}

.register {
    color: #334681;
    transition: all 0.3s;
    cursor: pointer;
}
.type-box-second{
    height: calc(100% - 100px);
    margin-top: 40px;
}
.type-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 100px);
    margin-top: 40px;

    #wxLoginContainer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        transform: scale(0.9);
    }
}
.icon-tishi{
    color: #e6a23c;
    font-size: 18px;
}
/deep/.el-button--primary.is-plain {
    color: #ffffff;
}
@media screen and (max-width:750px){
    .left-box{
        display: none;
    }
    .right-box{
        width: 100%;
    }
}
</style>
